import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const ApprovalResult = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const status = searchParams.get('status');
  const bookingId = searchParams.get('booking_id');

  const getStatusContent = () => {
    switch (status) {
      case 'approved':
        return {
          icon: <CheckCircle className="w-16 h-16 text-green-600" />,
          title: 'Appointment Approved',
          message: `Booking ${bookingId} has been confirmed. The patient will receive a confirmation email and the appointment has been added to your Google Calendar.`,
          bgColor: 'bg-green-50',
          borderColor: 'border-green-500'
        };
      case 'rejected':
        return {
          icon: <XCircle className="w-16 h-16 text-red-600" />,
          title: 'Appointment Rejected',
          message: `Booking ${bookingId} has been rejected. The patient has been notified.`,
          bgColor: 'bg-red-50',
          borderColor: 'border-red-500'
        };
      case 'already_processed':
        return {
          icon: <AlertCircle className="w-16 h-16 text-amber-600" />,
          title: 'Already Processed',
          message: `Booking ${bookingId} has already been processed. No action was taken.`,
          bgColor: 'bg-amber-50',
          borderColor: 'border-amber-500'
        };
      default:
        return {
          icon: <AlertCircle className="w-16 h-16 text-gray-600" />,
          title: 'Unknown Status',
          message: 'An unknown status was received.',
          bgColor: 'bg-gray-50',
          borderColor: 'border-gray-500'
        };
    }
  };

  const content = getStatusContent();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FDF9F5] via-[#E8EDE9] to-[#FDF9F5] flex items-center justify-center p-4">
      <Card className={`max-w-md w-full border-0 shadow-xl ${content.bgColor} border-l-4 ${content.borderColor}`}>
        <CardContent className="p-8 text-center">
          <div className="flex justify-center mb-6">
            {content.icon}
          </div>
          <h1 className="text-2xl font-serif font-bold text-[#2F5233] mb-4">
            {content.title}
          </h1>
          <p className="text-gray-600 mb-6">
            {content.message}
          </p>
          <div className="space-y-3">
            <Button 
              onClick={() => navigate('/admin/setup')}
              className="w-full bg-[#2F5233] hover:bg-[#2F5233]/90"
            >
              Go to Admin Setup
            </Button>
            <Button 
              variant="outline"
              onClick={() => navigate('/')}
              className="w-full"
            >
              Back to Home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ApprovalResult;
